"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgMoon = function SvgMoon(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m9.077 4.138.49-.103a.5.5 0 0 0-.973-.027l.483.13ZM5.862.922l.13.483a.5.5 0 0 0-.027-.972l-.103.49ZM8.667 5A3.667 3.667 0 0 1 5 8.666v1A4.667 4.667 0 0 0 9.667 5h-1Zm-.079-.76c.051.245.079.499.079.76h1c0-.33-.035-.654-.1-.965l-.979.206Zm.006-.232a2.125 2.125 0 0 1-2.05 1.572v1c1.444 0 2.66-.981 3.016-2.313l-.966-.259ZM6.544 5.58A2.123 2.123 0 0 1 4.42 3.456h-1A3.123 3.123 0 0 0 6.543 6.58v-1ZM4.42 3.456c0-.98.666-1.808 1.571-2.05L5.733.438A3.125 3.125 0 0 0 3.42 3.456h1ZM5 1.333c.26 0 .515.027.76.079l.205-.979A4.684 4.684 0 0 0 5 .333v1ZM1.333 5A3.667 3.667 0 0 1 5 1.333v-1A4.667 4.667 0 0 0 .333 5h1ZM5 8.666A3.667 3.667 0 0 1 1.333 5h-1A4.667 4.667 0 0 0 5 9.666v-1Z",
    fill: "#4D4D4D"
  }));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgMoon);
var _default = Memo;
exports["default"] = _default;